
/**
 * 上拉加载。
 * beforeDestory周期中执行解绑option.unbind();
 * 实例参考 live/list.vue 或 q/index.vue
 */

var dragload={
  _addScroll(){
    this.target.addEventListener("scroll",this._scrollHandle,false);
  },
  _removeScroll(){
    this.scrollTop=this._isWindow?this.target.scrollY:this.target.scrollTop;
    this.target.removeEventListener("scroll",this._scrollHandle,false);
    this.target=null;
  },
  _scroll(){
    var sy,ch,sh,box;
    if(this._isLoading)return;
    if(this._isWindow)
    {
      sy=this.target.scrollY;
      box=document.body;
    }
    else
    {
      sy=this.target.scrollTop,
        box=this.target;
    }
    ch=box.clientHeight;
    sh=box.scrollHeight;
    if(sy+ch>sh-10){
      this.statusText=this._statusTexts[1];
      this.apiRequest();
    }
  },
  apiRequest(){
    var _this=this;

    if(this._isLoading)return;
    this._isLoading=true;

    this.$http.get(this.api,this).then(function(res){
      var j=res.data,
        data=j.data,
        isList=Array.isArray(data),
        dataLen=isList?data.length:0,
        text;

      if(j.code===200){
        if(_this.pageNo){j.is_concat=1;}
        _this.pageNo++;
        _this.params.pageNo=_this.pageNo;

        if(isList){
          if(!dataLen&&_this.pageNo===1){
            text=_this._statusTexts[3];
          }
          else if(dataLen<_this.params.pageSize){
            text=_this._statusTexts[2];
          }
          else
          {
            text=_this._statusTexts[0];
            _this._isLoading=false;
          }
        }
        else
        {
          text=" ";
        }
      }
      else
      {
        text=j.error;
      }

      _this.statusText=text;

      _this.callback&&_this.callback(data,dataLen,text,j);
    }).catch(function(err){
      _this._isLoading=false;
      _this.error&&_this.error(err);
    });
  },
  statusTexts:["上拉加载更多...","数据加载中...","亲，到头了","暂无相关数据"],
  install(Vue,options){
    if(this.installed)return;
    var _this=this;
    this.installed=true;

    options=options||{};
    options.statusTexts=options.statusTexts||this.statusTexts;
    options.scrollHandle=Vue.prototype.debound(this._scroll,20);

    /**
     * 上拉加载
     * @return Object .bind() .unbind()
     */
    Vue.prototype.dragload=function(opts){
      opts._isWindow=opts.target===window;

      opts.params||(opts.params={pageNo:0,pageSize:5});
      opts.pageNo=opts.pageNo||0;
      if(opts.pageNo > 0) opts.concat=1;
      opts.apiRequest=_this.apiRequest;
      opts.bindTrigger=opts.bindTrigger!==false;
      opts.$http=options.$http;

      opts._statusTexts=opts.statusTexts||options.statusTexts;

      opts._scrollHandle=options.scrollHandle.bind(opts);
      opts.bind=_this._addScroll;
      opts.unbind=_this._removeScroll;
      opts.bind();

      opts.bindTrigger&&opts.apiRequest();

      return opts;
    };

  }
};

export default dragload;



// WEBPACK FOOTER //
// ./src/plugins/dragload/index.js